import { isEmbedded } from '../embedBridge.js';

/**
 * A provider whose card form is its own page (HOSTED_REDIRECT): the customer goes
 * there, and the provider sends them back to our return page, which waits for the
 * provider's answer.
 *
 * Running as a drop-in inside a merchant's page, this frame cannot take the whole
 * window there, and the provider's page may refuse to be framed — so it opens in a
 * new tab, and this frame moves to the return page to wait for the answer.
 */
export function open({ session, checkoutSessionId }) {
  if (isEmbedded()) {
    window.open(session.url, '_blank', 'noopener');
    window.location.assign(`/c/${encodeURIComponent(checkoutSessionId)}/return`);
  } else {
    window.location.assign(session.url);
  }
  // The page is leaving; nothing comes back here to resolve.
  return new Promise(() => {});
}

export default { open };
